/* eslint-disable @typescript-eslint/no-unused-vars */
import { createTool } from '@mastra/client-js'
import { z } from 'zod'
import store from 'src/store'
import { actions as appActions } from 'src/store/modules/app'

import {
  IUseRouterObjectPageSearchQuery,
  ObjectPageTabs,
} from 'src/hooks/router/useRouterObjectPage'

export const sendSMSTool = createTool({
  id: 'send-sms',
  description:
    'Send an SMS message to a contact. Use this when user wants to send a text message or when suggesting to send a message.',
  inputSchema: z.object({
    phoneNumber: z.string().describe('Recipient phone'),
    messageText: z.string().describe('SMS text'),
    objectSchemeIdentifier: z
      .string()
      .describe('Target object scheme (contact)'),
    objectUniqId: z.string().describe('Target object UUID'),
    parentSchemeIdentifier: z
      .string()
      .optional()
      .describe('Parent object scheme'),
    parentUniqId: z.string().optional().describe('Parent object UUID'),
    skipConfirmation: z
      .boolean()
      .optional()
      .default(false)
      .describe('Skip confirmation dialog'),
  }),
  outputSchema: z.object({
    success: z.boolean(),
    message: z.string(),
  }),

  execute: async (context: any) => {
    const {
      parentSchemeIdentifier,
      parentUniqId,
      objectSchemeIdentifier,
      objectUniqId,
      phoneNumber,
      messageText,
    } = context

    const skipConfirmation = false
    const querySearch: IUseRouterObjectPageSearchQuery = {
      objectPage: {
        selectedTab: ObjectPageTabs.MESSAGES,
        [ObjectPageTabs.MESSAGES]: {
          initialMessage: messageText,
        },
        ...(parentSchemeIdentifier && parentUniqId
          ? {
              selectedChildren: {
                schemeName: objectSchemeIdentifier,
                objectUniqId: objectUniqId,
              },
            }
          : {}),
      },
    }
    store.dispatch(
      appActions.navigate({
        path:
          parentSchemeIdentifier && parentUniqId
            ? `/storage/${parentSchemeIdentifier}/${parentUniqId}`
            : `/storage/${objectSchemeIdentifier}/${objectUniqId}`,
        search: querySearch,
      })
    )

    return {
      success: true,
      message: `${
        skipConfirmation ? 'Sending' : 'Preparing to send'
      } SMS to ${phoneNumber}`,
    }
  },
})
